"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import type { FloatingNavProps } from "./floating-nav.types";
import { NavBar } from "./nav-bar.component";
import { MobileNavSheet } from "./mobile-nav-sheet.component";
import { useFloatingNav } from "./use-floating-nav";
export function FloatingNav(t0) {
  const $ = _c(32);
  const {
    headline,
    items,
    className
  } = t0;
  const {
    sentinelRef,
    isVisible,
    isOpen,
    activeId,
    handleNavClick,
    handleToggle,
    handleScrollToTop
  } = useFloatingNav(items);
  if (!items || items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className || $[1] !== sentinelRef) {
    t1 = <div ref={sentinelRef} className={className} data-testid="floating-nav" aria-hidden="true" />;
    $[0] = className;
    $[1] = sentinelRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isVisible && !isOpen ? "translate-y-0" : isVisible && isOpen ? "translate-y-[calc(100%+2rem)] tablet:translate-y-0" : "translate-y-[calc(100%+2rem)]";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("fixed bottom-4 left-0 right-0 z-40", "flex justify-center", "screen-padding", "transition-transform duration-500 ease-out", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = headline || "Page navigation";
  let t5;
  if ($[5] !== activeId || $[6] !== handleNavClick || $[7] !== handleScrollToTop || $[8] !== handleToggle || $[9] !== headline || $[10] !== items) {
    t5 = <NavBar headline={headline} items={items} activeId={activeId} onToggle={handleToggle} onNavClick={handleNavClick} onScrollToTop={handleScrollToTop} />;
    $[5] = activeId;
    $[6] = handleNavClick;
    $[7] = handleScrollToTop;
    $[8] = handleToggle;
    $[9] = headline;
    $[10] = items;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <nav className={t3} aria-label={t4}>{t5}</nav>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = isVisible && isOpen ? "translate-y-0" : "translate-y-full";
  let t8;
  if ($[16] !== t7) {
    t8 = cn("fixed bottom-0 left-0 right-0 z-50 tablet:hidden", "transition-transform duration-300 ease-out", t7);
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== activeId || $[19] !== handleNavClick || $[20] !== handleScrollToTop || $[21] !== handleToggle || $[22] !== headline || $[23] !== items) {
    t9 = <MobileNavSheet headline={headline} items={items} activeId={activeId} onClose={handleToggle} onNavClick={handleNavClick} onScrollToTop={handleScrollToTop} />;
    $[18] = activeId;
    $[19] = handleNavClick;
    $[20] = handleScrollToTop;
    $[21] = handleToggle;
    $[22] = headline;
    $[23] = items;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <div className={t8} role="dialog" aria-label="Navigation menu">{t9}</div>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t1 || $[29] !== t10 || $[30] !== t6) {
    t11 = <>{t1}{t6}{t10}</>;
    $[28] = t1;
    $[29] = t10;
    $[30] = t6;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}